import { render, staticRenderFns } from "./CompareColumn.vue?vue&type=template&id=5e7f8ca9&"
import script from "./CompareColumn.vue?vue&type=script&lang=ts&"
export * from "./CompareColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports